import type { components } from "@/api/contract";
import { type SseEvent, streamSse } from "@/api/sse";

export type CreateRunRequest = components["schemas"]["CreateRunRequest"];

/**
 * POST /v1/chat/runs and stream the response. Thin wrapper over the SSE client
 * so the chat controller stays in the feature while the transport stays in
 * `api/`. Resolves when the stream ends; rejects on HTTP/transport error.
 */
export function streamChatRun(
  body: CreateRunRequest,
  opts: { signal?: AbortSignal; onEvent: (event: SseEvent) => void },
): Promise<void> {
  return streamSse({ path: "/v1/chat/runs", body, signal: opts.signal, onEvent: opts.onEvent });
}
